import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import * as Enc from 'encoding-japanese';
import { Define } from './define';
import { Timestamp } from 'firebase/firestore';

export class Utility {
    static str_to_unicode_array(str) {
        const arr = [];
        for (let i = 0; i < str.length; i++) {
            arr.push(str.charCodeAt(i));
        }
        return arr;
    }

    static downloadText(data, name, type = 'text/csv') {
        const anchor: any = document.createElement('a');
        if (window.URL && anchor.download !== undefined) {
            // // utf8
            // const bom = '\uFEFF';
            // const blob = new Blob([bom, data], { type: type });


            // sjis
            const unicodeArray = Utility.str_to_unicode_array(data);
            const sjisCodeArray = Enc.convert(
                unicodeArray, 'SJIS', 'UNICODE'
            );
            const uint8Array = new Uint8Array(sjisCodeArray);
            const blob = new Blob([uint8Array], { type: type });

            anchor.download = name;

            // window.URL.createObjectURLを利用
            // https://developer.mozilla.org/ja/docs/Web/API/URL/createObjectURL
            anchor.href = window.URL.createObjectURL(blob);

            // これでも可
            // anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(bom + data);

            // firefoxでは一度addしないと動かない
            document.body.appendChild(anchor);
            anchor.click();
            anchor.parentNode.removeChild(anchor);
        }
    }


    static downloadCSVZip(zipName: string, args: { data: any, name: string, folder: string }[]) {
        console.log(`downloadZip args count:${args.length}`);
        const zip = new JSZip();
        args.forEach(d => {
            console.log(d.name);
            const bom = '\uFEFF';
            const blob = new Blob([bom, d.data], { type: 'text/csv' });
            zip.folder(d.folder).file(d.name, blob);
        });
        zip.generateAsync({ type: 'blob' })
            .then(function (content) {
                saveAs(content, zipName);
            });
    }

    static downloadPDFZip(zipName: string, args: { data: any, name: string, folder: string }[]) {
      console.log(`downloadZip args count:${args.length}`);
      const zip = new JSZip();
      args.forEach(d => {
          console.log(d.name);
          zip.folder(d.folder).file(d.name, d.data);
      });
      zip.generateAsync({ type: 'blob' })
          .then(function (content) {
              saveAs(content, zipName);
          });
  }

    static convertDateToFullDateTime(date: Date, withoutDelimiter = false) {
        if (date === undefined || date === null) {
            return '';
        }
        // yyyy-MM-dd hh:mm:ssで返す
        if (!withoutDelimiter) {
            return ('0000' + date.getFullYear()).slice(-4) + '-'
                + ('00' + (date.getMonth() + 1)).slice(-2) + '-'
                + ('00' + date.getDate()).slice(-2) + ' '
                + ('00' + date.getHours()).slice(-2) + ':'
                + ('00' + date.getMinutes()).slice(-2) + ':'
                + ('00' + date.getSeconds()).slice(-2);
        } else {
            return ('0000' + date.getFullYear()).slice(-4)
                + ('00' + (date.getMonth() + 1)).slice(-2)
                + ('00' + date.getDate()).slice(-2)
                + ('00' + date.getHours()).slice(-2)
                + ('00' + date.getMinutes()).slice(-2)
                + ('00' + date.getSeconds()).slice(-2);
        }
    }

    static convertDateToDateMinite(date: Date, withoutDelimiter = false) {
        if (date === undefined || date === null) {
            return '';
        }
        // yyyy-MM-dd hh:mmで返す
        if (!withoutDelimiter) {
            return ('0000' + date.getFullYear()).slice(-4) + '-'
                + ('00' + (date.getMonth() + 1)).slice(-2) + '-'
                + ('00' + date.getDate()).slice(-2) + ' '
                + ('00' + date.getHours()).slice(-2) + ':'
                + ('00' + date.getMinutes()).slice(-2);
        } else {
            return ('0000' + date.getFullYear()).slice(-4)
                + ('00' + (date.getMonth() + 1)).slice(-2)
                + ('00' + date.getDate()).slice(-2)
                + ('00' + date.getHours()).slice(-2)
                + ('00' + date.getMinutes()).slice(-2);
        }
    }
    static convertDateToMinite(date: Date, withoutDelimiter = false) {
        if (date === undefined || date === null) {
            return '';
        }
        // hh:mmで返す
        if (!withoutDelimiter) {
            return ('00' + date.getHours()).slice(-2) + ':'
                + ('00' + date.getMinutes()).slice(-2);
        } else {
            return ('00' + date.getHours()).slice(-2)
                + ('00' + date.getMinutes()).slice(-2);
        }
    }
    static convertDateToDateText(date: Date, withoutDelimiter = false) {
        if (date === undefined || date === null) {
            return '';
        }
        // yyyy-MM-ddで返す
        if (!withoutDelimiter) {
            return ('0000' + date.getFullYear()).slice(-4) + '-'
                + ('00' + (date.getMonth() + 1)).slice(-2) + '-'
                + ('00' + date.getDate()).slice(-2);
        } else {
            return ('0000' + date.getFullYear()).slice(-4)
                + ('00' + (date.getMonth() + 1)).slice(-2)
                + ('00' + date.getDate()).slice(-2);
        }
    }

    static equalDay(a: Date, b: Date) {
        // 年月日の一致を判定する。
        return (a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate());
    }

    static compareDay(a: Date, b: Date) {
      // 年月日の大小を判定する。
      const aDay = {
        year: a.getFullYear(),
        month: a.getMonth() + 1,
        day: a.getDate()
      };
      const bDay = {
        year: b.getFullYear(),
        month: b.getMonth() + 1,
        day: b.getDate()
      };

      if (aDay.year === bDay.year) {
        if (aDay.month === bDay.month) {
          if (aDay.day < bDay.day) {
            return 1;
          } else if (aDay.day > bDay.day) {
            return -1;
          } else {
            return 0;
          }
        } else {
          if (aDay.month < bDay.month) {
            return 1;
          } else if (aDay.month > bDay.month) {
            return -1;
          }
        }
      } else {
        if (aDay.year < bDay.year) {
          return 1;
        } else if (aDay.year > bDay.year) {
          return -1;
        }
      }
  }

    static createDateFromText(text: string): Date {
        try {
            const result =  new Date(
                Number(text.slice(0, 4)),
                Number(text.slice(5, 7)) - 1,
                Number(text.slice(8, 10)),
                Number(text.slice(11, 13)),
                Number(text.slice(14, 16)),
                Number(text.slice(17, 19)));
            return result;
        } catch {
            console.log('createDateFromText error text:%s', text);
            return undefined;
        }
    }

    static getBusinessDate(kind: number, timeStamp: Date) {
        let targetDate: Date;
        if (kind === Define.RequestKindDef.CancelReenter || kind === Define.RequestKindDef.CancelTemporaryLeave) {
          targetDate = new Date(timeStamp);
        } else {
          if (timeStamp.getHours() <= 4) {
            const tmpDate = new Date(timeStamp);
            tmpDate.setDate(tmpDate.getDate() - 1);
            targetDate = new Date(tmpDate);
          } else {
            targetDate = new Date(timeStamp);
          }
        }
        return targetDate;
    }

    // 日本との時差分ずらす
    static convertDateToLocalTime(date: Date): Date {
        // ローカルのタイムゾーンオフセットを取得
        // getTimezoneOffset()はローカルから見た協定世界時(UTC)までの分差を返す。日本ならば -540分(-9時間)
        const timezoneOffsetHour = -date.getTimezoneOffset() / 60; // UTC+9などと表記がぶれるため 正負反転
        // 日本(基準時間)との時差計算
        const timeDiff = 9 - timezoneOffsetHour;
        const localTime: Date = new Date(date);
        localTime.setHours(localTime.getHours() - timeDiff);
        // console.log(timezoneOffsetHour);
        // console.log(timeDiff);
        // console.log(localTime);
        return localTime;
    }

    static convertLocalTimeToJstDate(date: Date): Date {
        // ローカルのタイムゾーンオフセットを取得
        // getTimezoneOffset()はローカルから見た協定世界時(UTC)までの分差を返す。日本ならば -540分(-9時間)
        const timezoneOffsetHour = -date.getTimezoneOffset() / 60; // UTC+9などと表記がぶれるため 正負反転
        // 日本(基準時間)との時差計算
        const timeDiff = 9 - timezoneOffsetHour;
        const JstDate: Date = new Date(date);
        JstDate.setHours(JstDate.getHours() + timeDiff);
        return JstDate;
    }

    static convertDateToTimestamp(date: Date) {
        const localTime = this.convertDateToLocalTime(date);
        return Timestamp.fromDate(localTime);
        // 旧実装: Timestamp.fromMillis(Math.floor(date.getTime() / 1000)).
    }

    static diffDay(target: Date, stamp: Date): number {
      // 演算の誤差で範囲外を出ないようにクランプ関数で上下限を制限
      const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max);
      // 基準日の日付以降は0とする。
      const targetDay = new Date(target.getFullYear(),target.getMonth(),target.getDate(), 0, 0, 0, 0);
      const diffTime = stamp.getTime() - targetDay.getTime();
      return clamp(Math.floor(diffTime / (1000 * 60 * 60 * 24)), -1, 1);
    }
}
